import { Stack, Typography } from '@mui/material';
import CustomButton from 'components/Common/CustomButton';
import InfoModal from 'components/Common/InfoModal';
import MuiLoader from 'components/Common/Loader';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { formatAmount } from 'utils/helpers';
interface DailyLimitModalProps {
    setLimitModal: (value: boolean) => void;
    limitModal: boolean;
    isReceiverBusiness: boolean;
    loading: boolean;
}
const DailyLimitModal = ({ setLimitModal, limitModal, isReceiverBusiness, loading }: DailyLimitModalProps) => {
    const dailyLimits = useSelector((state: RootState) => state.dailyLimit?.dailyLimits || {});
    const {
        dailyReceiveLimit = 0,
        dailyRemainingReceiveLimit = 0,
        dailyM2pSendLimit = 0,
        dailyM2pRemainingSendLimit = 0,
        dailyM2mSendLimit = 0,
        dailyM2mRemainingSendLimit = 0,
        LIMIT_START_TIME = '',
    } = dailyLimits || {};

    const getSendLimit = () => (isReceiverBusiness ? dailyM2mSendLimit : dailyM2pSendLimit);
    const getRemainingSendLimit = () => (isReceiverBusiness ? dailyM2mRemainingSendLimit : dailyM2pRemainingSendLimit);

    return (
        <InfoModal isOpen={limitModal} onClose={() => setLimitModal(false)} title={'Daily Limits'} hideActionButtons>
            {
                <>
                    {loading ? (
                        <Stack width={'100%'} height={235} justifyContent={'center'}>
                            <MuiLoader loading={loading} />
                        </Stack>
                    ) : (
                        <Stack gap={3} alignItems={'center'}>
                            <Stack width={'100%'} alignItems={'start'}>
                                {getSendLimit() ? <Typography>{`Daily Limit: ${formatAmount(getSendLimit())}`}</Typography> : null}
                                {getRemainingSendLimit() ? (
                                    <Typography ml={2} fontSize={'14px'}>
                                        {`Remaining Today: ${formatAmount(getRemainingSendLimit())}`}
                                    </Typography>
                                ) : null}
                            </Stack>
                            <Stack width={'100%'} alignItems={'start'}>
                                {dailyReceiveLimit ? <Typography>{`Receive Limit: ${formatAmount(dailyReceiveLimit)}`}</Typography> : null}
                                {dailyRemainingReceiveLimit ? (
                                    <Typography ml={2} fontSize={'14px'}>
                                        {`Remaining Today: ${formatAmount(dailyRemainingReceiveLimit)}`}
                                    </Typography>
                                ) : null}
                            </Stack>
                            <Stack>{LIMIT_START_TIME && <Typography>{`Daily limit reset ${LIMIT_START_TIME}`}</Typography>}</Stack>
                            <CustomButton title="Continue" onClick={() => setLimitModal(false)} />
                        </Stack>
                    )}
                </>
            }
        </InfoModal>
    );
};
export default DailyLimitModal;
